import React, { Fragment, forwardRef, useState, useCallback } from 'react';
import cn from 'classnames';
import { price } from '../../utils/format';

const BriefPackagePlan = ({ plan, active = false }) => {
  const [expanded, setExpanded] = useState(false);
  const handleToggle = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();
      setExpanded(!expanded);
    },
    [expanded],
  );
  return (
    <div
      className={cn('getting-started_packages-item -info', {
        '-active': active,
        '-expanded': expanded,
      })}
      onClick={handleToggle}
    >
      {!expanded && (
        <Fragment>
          <div
            className="getting-started_packages-item-title"
            dangerouslySetInnerHTML={{ __html: plan.name }}
          />
          {plan.price && (
            <div className="getting-started_packages-item-price">{price(plan.price)}</div>
          )}
          <div className="getting-started_packages-item-info">{plan.title2}</div>
          <div className="getting-started_packages-item-more" onClick={handleToggle}>
            View Details +
          </div>
        </Fragment>
      )}
      {expanded && (
        <Fragment>
          <span className="getting-started_packages-item-close" onClick={handleToggle} />
          <ul className="getting-started_packages-item-description">
            {plan.description
              .split('\n')
              .filter(Boolean)
              .map((chunk, index) => (
                <li
                  key={index}
                  dangerouslySetInnerHTML={{ __html: chunk }}
                  className={cn({
                    '-empty': chunk.includes('Your final design includes'),
                  })}
                />
              ))}
          </ul>
        </Fragment>
      )}
    </div>
  );
};

export default BriefPackagePlan;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefPackage/BriefPackagePlan.js